module.exports = __webpack_public_path__ + "img/16-8.d2ac9252.jpg";